module.exports = __webpack_public_path__ + "static/media/down-arrow.c6dc273b.svg";